import { render, staticRenderFns } from "./IconCountry.vue?vue&type=template&id=246b87b0"
import script from "./IconCountry.vue?vue&type=script&lang=js"
export * from "./IconCountry.vue?vue&type=script&lang=js"
import style0 from "./IconCountry.vue?vue&type=style&index=0&id=246b87b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports